import { render } from "./UserDashBoard.vue?vue&type=template&id=e825275e"
import script from "./UserDashBoard.vue?vue&type=script&lang=js"
export * from "./UserDashBoard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\estimate\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__